module.exports = __webpack_public_path__ + "static/media/ac-absence.e028ccf5.svg";